module.exports = __webpack_public_path__ + "img/tarjeta-outline-gray.6bbf033b.svg";